export default {
    fetchProfileDescription: 'FETCH_PROFILE_DESCRIPTION',
    fetchEducations: 'FETCH_EDUCATIONS',
    fetchExperiences: 'FETCH_EXPERIENCES',
    fetchPhoto: 'FETCH_PHOTO',
    fetchSeniorityLevel: 'FETCH_SENIORITY_LEVEL',
    fetchProfileDescriptionRule: 'FETCH_PROFILE_DESCRIPTION_RULE',
    fetchActivityAreas: 'FETCH_ACTIVITY_AREAS',
    fetchCompletionFormData: 'FETCH_COMPLETION_FORM_DATA',
    updateEducations: 'UPDATE_EDUCATIONS',
    editExperience: 'EDIT_EXPERIENCE',
    addExperience: 'ADD_EXPERIENCE',
    deleteExperience: 'DELETE_EXPERIENCE',
    updateProfileDescription: 'UPDATE_PROFILE_DESCRIPTION',
    updateSeniority: 'UPDATE_SENIORITY_LEVEL',
    updateProfilePreference: 'UPDATE_PROFILE_PREFERENCE',
    uploadLinkedinResume: 'UPLOAD_LINKEDIN_RESUME',
    fetchCurrentStep: 'FETCH_CURRENT_STEP',
    updateCurrentStep: 'UPDATE_CURRENT_STEP',
    confirmApplicationStatus: 'CONFIRM_APPLICATION_STATUS',
};
